import { configureStore } from '@reduxjs/toolkit';
import partner from './reducers';

const store = configureStore({
    reducer: {
      partner: partner
    }
})

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
//  export type AppDispatch = typeof store.dispatch